export const convertReportStatus = (
  statusList,
  count,
  currentStatus = null
) => {
  const total = Object.keys(count).reduce(
    (sum, currentCount) => sum + count[currentCount],
    0
  );

  const convertedCount = statusList.map((status) => {
    const key = Object.keys(count).find(
      (key) => key.toLowerCase() === status.value
    );
    return {
      ...status,
      count: status.value === "semua" ? total : count[key] || 0,
      active: status.value === currentStatus ? true : false,
    };
  });

  return convertedCount;
};
